import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, custom }: Theme) => ({
  footer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: custom.form.maxWidth,
  },
  newStyleRoot: {
    maxWidth: '730px',
  },
  paymentInfoWrapper: {
    maxWidth: '730px',
    marginTop: 16,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paymentInfo: {
    textAlign: 'right',
    color: custom.grey[2],
    fontSize: 14,
    lineHeight: '20px',
  },
  [breakpoints.down(485)]: {
    footer: {
      flexWrap: 'wrap-reverse',
      '& > button': {
        width: '100%',
        '&:not(:first-child)': {
          marginBottom: 15,
        },
      },
    },
  },
}));
